/* ============================================================
   METHODIST — Quiz El Método · motor
   Archivo: assets/metodo-quiz.js

   No contiene textos, precios ni estilos: eso vive en
   assets/metodo-quiz.json y en los ajustes de la sección.
   Aquí está la mecánica: puntajes, decisión, render,
   captura de datos y eventos.

   Eventos que emite (prefijo configurable en la sección):
     quiz_start · quiz_step · quiz_email · quiz_complete · quiz_add_to_cart
   Los manda a: gtag, fbq, dataLayer,
   Shopify.analytics.publish (pixeles personalizados) y
   document.dispatchEvent (CustomEvent, para cualquier app).
   ============================================================ */

(function () {
  "use strict";

  if (window.__metodoQuizCargado) return;
  window.__metodoQuizCargado = true;

  var pad = function (n) { return String(n).padStart(2, "0"); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };
  var mx = function (n) { return "$" + Number(n).toLocaleString("es-MX") + " MXN"; };
  var bool = function (v, def) { return v === undefined || v === "" ? !!def : v === "true"; };

  function iniciar() {
    document.querySelectorAll("[data-mtd-quiz]").forEach(function (root) {
      if (root.dataset.mtdListo === "1") return;
      root.dataset.mtdListo = "1";
      arrancar(root);
    });
  }
  document.addEventListener("DOMContentLoaded", iniciar);
  document.addEventListener("shopify:section:load", iniciar);
  iniciar();

  function arrancar(root) {
    var stage = root.querySelector("[data-mtd-stage]");
    var url = root.dataset.datos;
    if (!url) {
      stage.innerHTML = '<p class="mtd-loading">Falta el archivo de datos en los ajustes de la sección.</p>';
      return;
    }
    fetch(url, { cache: "no-cache" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) { new Quiz(root, data).intro(); })
      .catch(function (e) {
        stage.innerHTML = '<p class="mtd-loading">No se pudo cargar el diagnóstico. Revisa que el archivo ' +
          esc(url.split("/").pop().split("?")[0]) + " esté subido en Assets.</p>";
        console.error("[Quiz El Método]", e);
      });
  }

  /* ---------- constructor ---------- */
  function Quiz(root, data) {
    var d = root.dataset;
    this.root = root;
    this.d = data;
    this.cfg = {
      descuento: d.descuento || "",
      endpoint: d.endpoint || "",
      crearCliente: bool(d.crearCliente, true),
      etiquetas: d.etiquetas || "quiz",
      etiquetasExtra: (d.etiquetasExtra || "").split(",").map(function (t) { return t.trim(); }).filter(Boolean),
      mostrarCorreo: bool(d.mostrarCorreo, true),
      correoObligatorio: bool(d.correoObligatorio, false),
      pedirWhatsapp: bool(d.pedirWhatsapp, false),
      whatsappObligatorio: bool(d.whatsappObligatorio, false),
      whatsappLabel: d.whatsappLabel || "WhatsApp",
      whatsappPlaceholder: d.whatsappPlaceholder || "",
      eventos: bool(d.eventos, true),
      eventoPrefijo: d.eventoPrefijo || "methodist",
      eventoPixel: bool(d.eventoPixel, true),
      eventoDom: bool(d.eventoDom, true),
      autoAvanzar: bool(d.autoAvanzar, true),
      progreso: bool(d.progreso, true),
      portadaLayout: d.portadaLayout || "lado",
      titulo: d.titulo || "",
      eyebrow: d.eyebrow || "",
      texto: d.texto || "",
      cta: d.cta || "Empezar",
      datos: [d.dato1, d.dato2, d.dato3]
    };
    this.img = { portada: null, resultado: null, preguntas: {} };
    var tag = root.querySelector("[data-mtd-imagenes]");
    if (tag) { try { this.img = JSON.parse(tag.textContent); } catch (e) {} }

    this.stage = root.querySelector("[data-mtd-stage]");
    this.top = root.querySelector("[data-mtd-top]");
    this.bar = root.querySelector("[data-mtd-bar]");
    this.count = root.querySelector("[data-mtd-count]");
    this.q = data.preguntas || [];
    this.i = -1;
    this.a = {};
    this.cuerpo = false;
    this.email = "";
    this.tel = "";
  }

  /* ---------- eventos ---------- */
  Quiz.prototype.evento = function (nombre, params) {
    if (!this.cfg.eventos && !this.cfg.eventoPixel && !this.cfg.eventoDom) return;
    var completo = this.cfg.eventoPrefijo + ":" + nombre;
    var datos = params || {};
    if (this.cfg.eventos) {
      try { if (window.gtag) window.gtag("event", nombre, datos); } catch (e) {}
      try { if (window.fbq) window.fbq("trackCustom", completo, datos); } catch (e) {}
      try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: completo }, datos)); } catch (e) {}
    }
    if (this.cfg.eventoPixel) {
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish(completo, datos);
        }
      } catch (e) {}
    }
    if (this.cfg.eventoDom) {
      try { document.dispatchEvent(new CustomEvent(completo, { detail: datos, bubbles: true })); } catch (e) {}
    }
  };

  /* ---------- render base ---------- */
  Quiz.prototype.pintar = function (html) {
    this.stage.innerHTML = html;
    if (this.stage.firstElementChild) this.stage.firstElementChild.classList.add("fade");
    this.progreso();
    if (this.i > 0 || this.i === this.q.length) {
      var y = this.root.getBoundingClientRect().top + window.pageYOffset - 10;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  Quiz.prototype.progreso = function () {
    if (!this.cfg.progreso) { this.top.hidden = true; return; }
    var total = this.q.length;
    if (this.i < 0) { this.top.hidden = true; return; }
    this.top.hidden = false;
    var listo = this.i >= total;
    this.bar.style.width = (listo ? 100 : (this.i / total) * 100) + "%";
    this.count.textContent = listo ? "Resultado" : pad(Math.min(this.i + 1, total)) + " / " + pad(total);
  };

  Quiz.prototype.figura = function (im, clase) {
    if (!im || !im.src) return "";
    return (
      '<figure class="' + clase + '">' +
        '<img src="' + esc(im.src) + '" alt="' + esc(im.alt || "") + '" loading="lazy" decoding="async">' +
        (im.pie ? "<figcaption>" + esc(im.pie) + "</figcaption>" : "") +
      "</figure>"
    );
  };

  /* ---------- portada ---------- */
  Quiz.prototype.intro = function () {
    var self = this;
    this.i = -1;

    var datos = this.cfg.datos.filter(Boolean).map(function (t) {
      var p = String(t).split("|");
      return '<div class="fact"><b>' + esc((p[0] || "").trim()) + "</b><span>" + esc((p[1] || "").trim()) + "</span></div>";
    }).join("");

    var im = this.img.portada;
    var layout = im && im.src ? this.cfg.portadaLayout : "sin";
    var texto =
      '<div class="hero-copy">' +
        (this.cfg.eyebrow ? '<div class="mono eyebrow">' + esc(this.cfg.eyebrow) + "</div>" : "") +
        "<h1>" + esc(this.cfg.titulo) + "</h1>" +
        '<p class="lead">' + esc(this.cfg.texto) + "</p>" +
        (datos ? '<div class="facts">' + datos + "</div>" : "") +
        '<button class="btn" type="button" data-go>' + esc(this.cfg.cta) + "</button>" +
      "</div>";

    var html;
    if (layout === "lado") {
      html = '<div class="hero hero--lado">' + texto + this.figura(im, "hero-img") + "</div>";
    } else if (layout === "arriba") {
      html = '<div class="hero">' + this.figura(im, "hero-img") + texto + "</div>";
    } else if (layout === "fondo") {
      html = '<div class="hero hero--fondo"><div class="hero-bg"><img src="' + esc(im.src) +
        '" alt="' + esc(im.alt || "") + '" loading="lazy"></div>' + texto + "</div>";
    } else {
      html = '<div class="hero">' + texto + "</div>";
    }

    this.pintar(html);
    this.stage.querySelector("[data-go]").onclick = function () {
      self.evento("quiz_start", {});
      self.i = 0;
      self.render();
    };
  };

  /* ---------- preguntas ---------- */
  Quiz.prototype.render = function () {
    var self = this;
    if (this.i >= this.q.length) return this.cfg.mostrarCorreo ? this.correo() : this.resultado();

    var q = this.q[this.i];
    var cur = this.a[q.id];
    var sel = q.tipo === "multi" ? (cur || []) : (cur ? [cur] : []);
    var esUltima = this.i === this.q.length - 1;
    var im = this.img.preguntas ? this.img.preguntas[q.id] : null;
    var lado = im && im.posicion === "lado";

    var opciones = q.opciones.map(function (o) {
      return (
        '<button class="opt" type="button" data-v="' + esc(o.valor) + '" data-multi="' + (q.tipo === "multi") + '"' +
        ' aria-pressed="' + (sel.indexOf(o.valor) > -1) + '">' +
          '<span class="mark" aria-hidden="true"><i></i></span>' +
          '<span class="t">' + esc(o.texto) + (o.detalle ? '<span class="d">' + esc(o.detalle) + "</span>" : "") + "</span>" +
        "</button>"
      );
    }).join("");

    var extra = q.extra
      ? '<button class="opt extra" type="button" data-extra data-multi="true" aria-pressed="' + this.cuerpo + '">' +
          '<span class="mark" aria-hidden="true"><i></i></span>' +
          '<span class="t">' + esc(q.extra.label) + '<span class="d">' + esc(q.extra.hint || "") + "</span></span>" +
        "</button>"
      : "";

    var cuerpoPregunta =
      '<div class="q-head">' +
        '<div class="mono eyebrow">Pregunta ' + pad(this.i + 1) + " de " + pad(this.q.length) + "</div>" +
        "<h2>" + esc(q.pregunta) + "</h2>" +
        '<p class="q-why">' + esc(q.porque || "") + "</p>" +
        (q.tipo === "multi" ? '<p class="mono muted" style="margin-top:14px">Puedes elegir hasta ' + (q.max || 3) + "</p>" : "") +
      "</div>" +
      '<div class="opts" data-opts>' + opciones + "</div>" + extra +
      '<div class="q-foot">' +
        (this.i > 0 ? '<button class="linkish" type="button" data-back>← Anterior</button>' : "<span></span>") +
        '<button class="btn" type="button" data-next' + (sel.length ? "" : " disabled") + ">" +
          (esUltima ? "Ver mi protocolo" : "Continuar") +
        "</button>" +
      "</div>";

    this.pintar(
      lado
        ? '<div class="q q--lado">' + this.figura(im, "q-img") + "<div>" + cuerpoPregunta + "</div></div>"
        : '<div class="q">' + this.figura(im, "q-img") + cuerpoPregunta + "</div>"
    );

    var next = this.stage.querySelector("[data-next]");
    var botones = this.stage.querySelectorAll("[data-opts] .opt");

    botones.forEach(function (btn) {
      btn.onclick = function () {
        var v = btn.dataset.v;
        var o = q.opciones.filter(function (x) { return x.valor === v; })[0];

        if (q.tipo !== "multi") {
          self.a[q.id] = v;
          botones.forEach(function (b) { b.setAttribute("aria-pressed", b === btn); });
          next.disabled = false;
          self.evento("quiz_step", { step: self.i + 1, pregunta: q.id, respuesta: v });
          if (self.cfg.autoAvanzar) setTimeout(function () { self.i++; self.render(); }, 220);
          return;
        }

        var arr = self.a[q.id] || [];
        var max = q.max || 3;
        var soloIds = q.opciones.filter(function (x) { return x.excluyente; }).map(function (x) { return x.valor; });

        if (o && o.excluyente) {
          arr = arr.indexOf(v) > -1 ? [] : [v];
        } else {
          arr = arr.filter(function (x) { return soloIds.indexOf(x) < 0; });
          if (arr.indexOf(v) > -1) arr = arr.filter(function (x) { return x !== v; });
          else if (arr.length < max) arr = arr.concat(v);
        }
        self.a[q.id] = arr;
        botones.forEach(function (b) { b.setAttribute("aria-pressed", arr.indexOf(b.dataset.v) > -1); });
        next.disabled = !arr.length;
      };
    });

    var ex = this.stage.querySelector("[data-extra]");
    if (ex) ex.onclick = function () { self.cuerpo = !self.cuerpo; ex.setAttribute("aria-pressed", self.cuerpo); };

    var back = this.stage.querySelector("[data-back]");
    if (back) back.onclick = function () { self.i--; self.render(); };

    next.onclick = function () {
      if (next.disabled) return;
      self.evento("quiz_step", { step: self.i + 1, pregunta: q.id, respuesta: String(self.a[q.id]) });
      self.i++;
      self.render();
    };
  };

  /* ---------- correo y WhatsApp ---------- */
  Quiz.prototype.correo = function () {
    var self = this;
    var t = this.d.pantalla_correo || {};
    var campoTel = this.cfg.pedirWhatsapp
      ? '<div class="field">' +
          '<label class="mono" for="mtd-tel">' + esc(this.cfg.whatsappLabel) +
            (this.cfg.whatsappObligatorio ? "" : " (opcional)") + "</label>" +
          '<input id="mtd-tel" type="tel" inputmode="tel" autocomplete="tel" placeholder="' + esc(this.cfg.whatsappPlaceholder) + '">' +
          '<div class="err" data-err-tel hidden>Escribe 10 dígitos.</div>' +
        "</div>"
      : "";

    this.pintar(
      '<div class="mail">' +
        '<div class="mono eyebrow">' + esc(t.eyebrow) + "</div>" +
        "<h2>" + esc(t.titulo) + "</h2>" +
        '<p class="q-why">' + esc(t.texto) + "</p>" +
        '<div class="field">' +
          '<label class="mono" for="mtd-email">' + esc(t.label) + "</label>" +
          '<input id="mtd-email" type="email" inputmode="email" autocomplete="email" placeholder="' + esc(t.placeholder) + '">' +
          '<div class="err" data-err hidden>' + esc(t.error) + "</div>" +
        "</div>" +
        campoTel +
        '<div class="cta-row">' +
          '<button class="btn" type="button" data-send>' + esc(t.cta) + "</button>" +
          (this.cfg.correoObligatorio ? "" : '<button class="linkish" type="button" data-skip>' + esc(t.saltar) + "</button>") +
        "</div>" +
        '<p class="legal">' + esc(t.legal) + "</p>" +
      "</div>"
    );

    var input = this.stage.querySelector("#mtd-email");
    var tel = this.stage.querySelector("#mtd-tel");

    var enviar = function () {
      var v = (input.value || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        self.stage.querySelector("[data-err]").hidden = false;
        input.focus();
        return;
      }
      var n = tel ? (tel.value || "").replace(/\D/g, "") : "";
      if (tel && (self.cfg.whatsappObligatorio || n) && n.length < 10) {
        self.stage.querySelector("[data-err-tel]").hidden = false;
        tel.focus();
        return;
      }
      self.email = v;
      self.tel = n;
      self.guardarLead();
      self.resultado();
    };

    this.stage.querySelector("[data-send]").onclick = enviar;
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") enviar(); });
    if (tel) tel.addEventListener("keydown", function (e) { if (e.key === "Enter") enviar(); });

    var skip = this.stage.querySelector("[data-skip]");
    if (skip) skip.onclick = function () { self.evento("quiz_email", { capturado: false }); self.resultado(); };
  };

  /* ---------- guardado del lead ---------- */
  Quiz.prototype.etiquetasLead = function (dec) {
    var p = this.cfg.etiquetas;
    var t = [p, p + "-" + dec.eje, p + "-linea-" + dec.aroma, p + "-pasos-" + (this.a.pasos || ""), p + "-" + dec.size + "ml"];
    if (this.cuerpo) t.push(p + "-cuerpo");
    return t.concat(this.cfg.etiquetasExtra).filter(Boolean);
  };

  Quiz.prototype.guardarLead = function () {
    var self = this;
    var dec = this.decidir();
    var etiquetas = this.etiquetasLead(dec);
    var payload = {
      email: this.email,
      whatsapp: this.tel || null,
      perfil: this.a,
      cuerpo: this.cuerpo,
      eje: dec.eje,
      aroma: dec.aroma,
      tamano: dec.size,
      set: dec.set.nombre,
      set_handle: dec.set.handle,
      variant_id: dec.variante.variant_id,
      valor: dec.variante.precio,
      etiquetas: etiquetas,
      fecha: new Date().toISOString()
    };

    try { localStorage.setItem("mtd_quiz", JSON.stringify(payload)); } catch (e) {}

    /* 1. Cliente en Shopify con etiquetas → esto es lo que ve Shopify Flow */
    if (this.cfg.crearCliente) {
      var body = new URLSearchParams();
      body.append("form_type", "customer");
      body.append("utf8", "✓");
      body.append("contact[email]", this.email);
      body.append("contact[tags]", etiquetas.join(","));
      if (this.tel) body.append("contact[phone]", this.tel);
      fetch("/contact#newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString()
      }).catch(function (e) { console.warn("[Quiz El Método] no se pudo crear el cliente", e); });
    }

    /* 2. Webhook propio (Messagi, Klaviyo, Make, Zapier) */
    if (this.cfg.endpoint) {
      fetch(this.cfg.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }).catch(function (e) { console.warn("[Quiz El Método] webhook falló", e); });
    }

    if (!this.cfg.endpoint && !this.cfg.crearCliente) {
      console.log("[Quiz El Método] lead sin destino configurado:", payload);
    }

    this.evento("quiz_email", {
      capturado: true, whatsapp: !!this.tel, eje: dec.eje, aroma: dec.aroma, etiquetas: etiquetas.join(",")
    });
  };

  /* ---------- motor ---------- */
  Quiz.prototype.puntajes = function () {
    var sc = { scalp: 0, densidad: 0, repara: 0, hidra: 0 };
    var self = this;
    this.q.forEach(function (q) {
      var v = self.a[q.id];
      if (!v) return;
      (Array.isArray(v) ? v : [v]).forEach(function (val) {
        var o = q.opciones.filter(function (x) { return x.valor === val; })[0];
        if (o && o.puntos) Object.keys(o.puntos).forEach(function (k) { if (k in sc) sc[k] += o.puntos[k]; });
      });
    });
    return sc;
  };

  Quiz.prototype.cumple = function (si, sc) {
    if (!si || si === "default") return si === "default";
    if (si.contador) return sc[si.contador] >= (si.min || 0);
    if (si.respuesta) return (si.en || []).indexOf(this.a[si.respuesta]) > -1;
    if (si.multi) return (this.a[si.multi] || []).indexOf(si.contiene) > -1;
    if ("cuerpo" in si) return this.cuerpo === si.cuerpo;
    return false;
  };

  Quiz.prototype.decidir = function () {
    var self = this;
    var m = this.d.motor;
    var sc = this.puntajes();

    var size = (m.tamano.usar_500_si || []).some(function (c) { return self.cumple(c, sc); }) ? 500 : (m.tamano.default || 225);
    var aroma = sc.scalp + sc.densidad >= sc.repara + sc.hidra ? "romero" : "miel";
    var shampoo = m.aroma[aroma];
    var eje = Object.keys(sc).reduce(function (a, b) { return sc[b] > sc[a] ? b : a; }, "hidra");
    var pasos = this.a.pasos;
    var cuerpo = this.cuerpo;

    var ok = function (regla, real) { return regla === undefined || regla === "cualquiera" || regla === real; };
    var fila = m.mapeo.filter(function (r) {
      return ok(r.pasos, pasos) && ok(r.eje, eje) && ok(r.aroma, aroma) && (r.cuerpo === undefined || r.cuerpo === cuerpo);
    })[0] || m.mapeo[m.mapeo.length - 1];

    var items = (fila.productos || []).map(function (k) { return k === "shampoo" ? shampoo : k; });

    var addons = (fila.addons || []).slice();
    (m.addons_extra || []).forEach(function (a) { if (self.cumple(a.si, sc)) addons.push(a.producto); });
    addons = addons.filter(function (k, idx) {
      return items.indexOf(k) < 0 && addons.indexOf(k) === idx;
    }).slice(0, m.max_addons || 3);

    var set = this.d.sets[fila.set];
    var clave = set.usa_tamano && set.usa_aroma ? size + "|" + aroma : set.usa_tamano ? String(size) : "_";
    var variante = set.variantes[clave] || set.variantes[Object.keys(set.variantes)[0]];
    var suelto = items.reduce(function (t, k) { return t + self.precio(k, size); }, 0);

    return {
      sc: sc, size: size, aroma: aroma, eje: eje, set: set, items: items, addons: addons,
      variante: variante, suelto: suelto, ahorro: Math.max(0, suelto - variante.precio)
    };
  };

  Quiz.prototype.prod = function (k, size) {
    var p = this.d.productos[k] || {};
    if (p.por_tamano) {
      var v = p.por_tamano[String(size)] || p.por_tamano[Object.keys(p.por_tamano)[0]];
      return Object.assign({}, p, v);
    }
    return p;
  };
  Quiz.prototype.precio = function (k, size) { return this.prod(k, size).precio || 0; };

  Quiz.prototype.nivelDano = function (repara) {
    var u = this.d.motor.umbrales, e = this.d.resultado.dano;
    return repara >= u.dano_alto ? e.alto : repara >= u.dano_moderado ? e.moderado : e.bajo;
  };

  Quiz.prototype.porQue = function (k, dec) {
    var r = (this.d.resultado.por_que || {})[k];
    if (!r) return "";
    var txt = r.base || "";
    if (r.segun && r.textos) {
      var resp = this.a[r.segun];
      var extra;
      if (Array.isArray(resp)) {
        for (var i = 0; i < resp.length && !extra; i++) extra = r.textos[resp[i]];
      } else {
        extra = r.textos[resp];
      }
      if (extra === undefined || extra === null) extra = r.textos.default || "";
      txt = (extra ? extra + " " : "") + txt;
    }
    return esc(txt.replace(/\{size\}/g, dec.size).replace(/\{aroma\}/g, dec.aroma));
  };

  Quiz.prototype.diagnostico = function (dec) {
    var t = this.d.resultado.diagnostico, R = this.d.resultado, a = this.a, sc = dec.sc;
    var quim = (a.quimica || []).filter(function (x) { return x !== "ninguno"; });
    var nQuim = quim.length === 1 ? "un proceso químico" : quim.length + " procesos químicos";

    var p1 = t.apertura
      .replace("{textura}", R.etiqueta_textura[a.textura] || "mixto")
      .replace("{cuero}", R.etiqueta_cuero[a.cuero] || "un cuero cabelludo mixto") +
      " " + (t.por_largo[a.largo] || "");

    var p2 = t.dano.replace("{dano}", this.nivelDano(sc.repara)) + " " +
      (quim.length ? t.con_quimica.replace("{n_quimica}", nQuim) : t.sin_quimica) + " " +
      (t.por_calor[a.calor] || "") + " " +
      (sc.hidra >= this.d.motor.umbrales.hidratacion_alta ? t.hidratacion_alta : t.hidratacion_normal);

    var p3 = t.por_caida[a.caida] || "";
    var p4 = t.cierre.replace("{eje}", R.nombre_eje[dec.eje]);

    return "<p>" + esc(p1) + "</p><p>" + esc(p2) + "</p><p>" + esc(p3) + "</p><p><b>" + esc(p4) + "</b></p>";
  };

  Quiz.prototype.frecuenciaUso = function (k) {
    var lav = {
      diario: "en cada lavado (diario)", dos: "en cada lavado (cada 2 días)",
      tres: "en cada lavado (cada 3 días)", semana: "en cada lavado (1–2 por semana)"
    }[this.a.frecuencia] || "en cada lavado";
    return {
      shMiel: lav, shRomero: lav, acond: lav, serum: "diario, cabello húmedo",
      tonico: "diario, sin enjuagar", body: "diario, piel limpia", jabon: "diario, en ducha"
    }[k] || "";
  };

  /* ---------- resultado ---------- */
  Quiz.prototype.resultado = function () {
    var self = this;
    this.i = this.q.length;
    var dec = this.decidir();
    var R = this.d.resultado, L = R.etiquetas, T = R.titulos_secciones;
    var carrito = "/cart/" + dec.variante.variant_id + ":1" +
      (this.cfg.descuento ? "?discount=" + encodeURIComponent(this.cfg.descuento) : "");

    var pasos = dec.items.map(function (k) {
      var p = self.prod(k, dec.size);
      return (
        '<div class="step"><div class="no num">' + esc(p.paso) + "</div><div>" +
          "<h3>" + esc(p.nombre) + "</h3>" +
          '<div class="meta"><span>' + esc(p.ml || "—") + "</span><span>" + esc(self.frecuenciaUso(k)) +
            "</span><span>" + esc(p.activos) + "</span></div>" +
          '<p class="body">' + esc(p.que_hace) + "</p>" +
          '<p class="how"><em>' + esc(L.que_hace) + ":</em> " + esc(p.como_usarlo) + "</p>" +
          '<p class="how"><em>' + esc(L.para_ti) + ":</em> " + self.porQue(k, dec) + "</p>" +
        "</div></div>"
      );
    }).join("");

    var ledger = dec.items.map(function (k) {
      var p = self.prod(k, dec.size);
      return "<div><span>" + esc(p.nombre) + (p.ml ? " · " + esc(p.ml) : "") +
        '</span><span class="num">' + mx(p.precio) + "</span></div>";
    }).join("");

    var addons = dec.addons.length
      ? '<div class="sec"><span class="mono">' + esc(T.addons) + '</span><div class="addons">' +
          dec.addons.map(function (k) {
            var p = self.prod(k, dec.size);
            return '<div class="addon"><div class="mono">Paso ' + esc(p.paso) + "</div><h3>" + esc(p.nombre) + "</h3>" +
              "<p>" + (self.porQue(k, dec) || esc(p.que_hace)) + "</p>" +
              '<div class="p">' + mx(p.precio) + ' · <a href="/products/' + esc(p.handle) + '">' + esc(L.ver_producto) + "</a></div></div>";
          }).join("") + "</div></div>"
      : "";

    var timeline = (R.que_esperar || []).filter(function (r) { return !r.si || self.cumple(r.si, dec.sc); })
      .map(function (r) { return '<div><span class="mono">' + esc(r.cuando) + "</span><span>" + esc(r.texto) + "</span></div>"; }).join("");

    var errores = (R.errores || []).filter(function (r) { return self.cumple(r.si, dec.sc); });
    if (!errores.length) errores = (R.errores || []).filter(function (r) { return r.si === "default"; });
    errores = errores.slice(0, R.max_errores || 4).map(function (r) { return "<li>" + esc(r.texto) + "</li>"; }).join("");

    this.pintar(
      '<div class="res">' +
        this.figura(this.img.resultado, "res-img") +
        '<div class="mono res-tag">' + esc(R.titulos_por_eje[dec.eje]) + " · " + esc(R.etiqueta_linea[dec.aroma]) + "</div>" +
        "<h1>" + esc(dec.set.nombre.replace("Set | ", "")) + "</h1>" +
        '<div class="chips">' +
          '<span class="chip"><b>' + esc(L.fibra) + ":</b> " + esc(R.etiqueta_textura[this.a.textura] || "mixta") + "</span>" +
          '<span class="chip"><b>' + esc(L.cuero) + ":</b> " + esc(this.a.cuero || "normal") + "</span>" +
          '<span class="chip"><b>' + esc(L.dano) + ":</b> " + esc(this.nivelDano(dec.sc.repara)) + "</span>" +
          '<span class="chip"><b>' + esc(L.densidad) + ":</b> " +
            esc(dec.sc.densidad >= 4 ? L.densidad_trabajar : L.densidad_estable) + "</span>" +
          '<span class="chip"><b>' + esc(L.tamano) + ":</b> " + dec.size + " ml</span>" +
        "</div>" +
        '<div class="dx">' + this.diagnostico(dec) + "</div>" +
        '<div class="sec"><span class="mono">' + esc(T.protocolo) + '</span><div class="steps">' + pasos + "</div></div>" +
        '<div class="sec"><span class="mono">' + esc(T.set) + "</span>" +
          '<div class="offer">' +
            '<div class="head"><div><h3>' + esc(dec.set.nombre) + "</h3>" +
              '<p class="muted" style="font-size:14.5px;max-width:46ch">' + esc(dec.set.claim) + "</p></div>" +
              '<div style="text-align:right"><div class="price num">' + mx(dec.variante.precio) + "</div>" +
              (dec.ahorro > 0 ? '<div class="strike num">' + mx(dec.suelto) + "</div>" : "") + "</div></div>" +
            '<div class="ledger">' + ledger +
              (dec.ahorro > 0 ? '<div class="save"><span>' + esc(L.ahorro) + '</span><span class="num">−' + mx(dec.ahorro) + "</span></div>" : "") +
              '<div class="tot"><span>' + esc(L.total) + '</span><span class="num">' + mx(dec.variante.precio) + "</span></div>" +
            "</div>" +
            '<div class="cta-row">' +
              '<a class="btn" href="' + carrito + '" data-cart>' + esc(R.cta_carrito) + "</a>" +
              '<a class="btn ghost" href="/products/' + esc(dec.set.handle) + '">' + esc(R.cta_set) + "</a>" +
            "</div>" +
            '<p class="legal">' + esc(R.nota_variante) + "</p>" +
          "</div>" +
        "</div>" +
        addons +
        '<div class="sec"><span class="mono">' + esc(T.esperar) + '</span><div class="tl">' + timeline + "</div></div>" +
        '<div class="sec"><span class="mono">' + esc(T.errores) + '</span><ul class="avoid">' + errores + "</ul></div>" +
        '<div class="cta-row" style="margin-top:34px">' +
          '<a class="btn" href="' + carrito + '" data-cart>' + esc(R.cta_carrito) + " — " + mx(dec.variante.precio) + "</a>" +
          '<button class="btn ghost" type="button" data-reset>' + esc(R.cta_reiniciar) + "</button>" +
        "</div>" +
        '<p class="note">' + esc(R.aviso) + "</p>" +
      "</div>"
    );

    this.evento("quiz_complete", {
      set: dec.set.nombre, variant_id: dec.variante.variant_id, valor: dec.variante.precio,
      eje: dec.eje, aroma: dec.aroma, tamano: dec.size, currency: "MXN"
    });

    this.stage.querySelectorAll("[data-cart]").forEach(function (a) {
      a.addEventListener("click", function () {
        self.evento("quiz_add_to_cart", {
          variant_id: dec.variante.variant_id, valor: dec.variante.precio, set: dec.set.nombre, currency: "MXN"
        });
      });
    });
    this.stage.querySelector("[data-reset]").onclick = function () {
      self.a = {}; self.cuerpo = false; self.email = ""; self.tel = ""; self.intro();
    };
  };
})();
